import { UnknownErrorComponent } from '@shared/components';

export function ErrorBoundary() {
  return <UnknownErrorComponent />;
}
